import React from 'react';

interface IProps {
  name?: string;
  phone: string;
  address1?: string;
  address2?: string;
}

const DepartmentContactItem = ({ name, phone, address1, address2 }: IProps) => {
  return (
    <div className="department-contacts-item" key={`${name}-${phone}`}>
      <p className="department-contacts-item">{address1}</p>
      {address2 && <p className="department-contacts-item">{address2}</p>}
      <a className="department-phone body-3 bold" href={`tel:${phone.replace(/ /g, '')}`} aria-label={`Phone ${phone}`}>
        {phone}
      </a>
      <span className="department-name caption">{name}</span>
    </div>
  );
};

export default DepartmentContactItem;
